
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    mixins: [ScreenSize],
    props: {
      organizationSocialIcons: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        icons: [],
      };
    },
    created() {
      this.organizationSocialIcons.map((icon) => {
        if (icon.href) {
          this.icons.push(icon);
        }
      });
    },
  };
